// extracted by mini-css-extract-plugin
export default {"container":"container--baL4m3Gu4c"};